export enum AttributeKey
{
    CURRENT_USER = 'current_user',
    LAST_SYNC = 'last_sync',
    CONSTANCE = 'constance_config',
    LAST_AUTHENTICATION = 'last_authentication'
}

export interface Attribute
{
    [key: string]: any;
    key: string;
    value?: any;
}

export interface CurrentUser extends Attribute
{
    id: number;
    language: string;
    token: string;
}

export interface LastAuthentication extends CurrentUser
{
    checksum: number;
    token: string;
}